import React, { useEffect } from 'react';
import { Space, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GeneralGrid from '../../../../Template/layoutComponents/GeneralGrid';
import { useTestBuilder } from './context/TestBuilderContext';
import useTemplateState from '../../../../Template/atoms/variables';
import { getTests } from './services/test.service.ts';
import { useMsal } from '@azure/msal-react';
import useSettingsState from '../../../atoms/variables';
const TestConfigurationList = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();

  const { categories } = useSettingsState();
  const { tests, setTests } = useTestBuilder();
  const { setPendingApiCalls } = useTemplateState();
  const { instance } = useMsal();

  const handleEdit = (item) => {
    navigate(`/settings/tests/${item.id}`);
  };

  const handleCreate = () => {
    navigate('/settings/tests/create');
  };

  useEffect(() => {
    if (!tests || tests.length === 0) {
      setPendingApiCalls((current) => current.concat(['getTests']));
      getTests(instance)
        .then((data) => {
          // Handle the correct payload structure - extract tests from items array
          setTests(data || []);
        })
        .finally(() => {
          setPendingApiCalls((current) => current.filter((item) => item !== 'getTests'));
        });
    }
  }, []);

  return (
    <GeneralGrid
      items={
        tests && tests.length > 0
          ? tests.map((test, index) => ({
              id: test.id || test._id?.$oid || test._id || index,
              name: test.title || 'Unnamed Test',
              description: (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                  <Space wrap style={{ maxWidth: '100%' }}>
                    {Array.isArray(test.assetCategories) ? (
                      test.assetCategories.map((category, idx) => (
                        <Tag key={idx} color='volcano'>
                          {category}
                        </Tag>
                      ))
                    ) : (
                      <Tag color='volcano'>{test.assetCategory}</Tag>
                    )}
                  </Space>
                  <Space>
                    <Tag color='blue' style={{ fontSize: '1rem' }}>
                      {test.code || 'N/A'}
                    </Tag>
                    <Tag
                      style={{ fontSize: '1rem' }}
                      color={test.platform === 'mobile' ? 'green' : 'purple'}
                    >
                      {test.platform
                        ? test.platform.charAt(0).toUpperCase() + test.platform.slice(1)
                        : 'N/A'}
                    </Tag>
                    <Tag color='cyan' style={{ fontSize: '1rem' }}>
                      {test.allowedAttempts || 0} {t('attempts')}
                    </Tag>
                  </Space>
                  <div style={{ fontSize: '0.9rem', color: '#666' }}>
                    {test.reportName || 'No report name'}
                  </div>
                </div>
              ),
            }))
          : []
      }
      onClickItem={handleEdit}
      onClickNew={handleCreate}
      hideCreateButton={false}
    />
  );
};

export default TestConfigurationList;
